module.exports = __webpack_public_path__ + "static/1-27e19ed9a6c645db8d9956c237d2d212.jpg";